import React from "react";
import { UI_COLORS } from "../config";
import SignInButton, {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "./commons/SignInButton/SignInButton";
import { Breadcrumb, ConfigProvider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import TenantSelector from "./TenantSelector";
/**
 * Application header component with branding and authentication
 */
function Header({ accounts, tenants, selectedTenant, onTenantSelect  }) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Breadcrumb: {
            itemColor: UI_COLORS.white,
            lastItemColor: UI_COLORS.white,
            separatorColor: UI_COLORS.white,
          },
        },
      }}
    >
      <header
        style={{ backgroundColor: UI_COLORS.secondary, height: 72 }}
        className="text-white p-4 shadow-md"
      >
        <div className="w-full px-6 flex items-center justify-between">
          <div className="flex items-center">
            <img src="/logo-RINA.png" alt="RINA Logo" className="h-10 mr-4" />
            <Breadcrumb
              className="text-xl font-bold mr-2 mb-0"
              style={{ fontSize: 21 }}
              separator={<FontAwesomeIcon icon={faCaretRight} />}
              items={[
                {
                  title: (
                    <img
                      src="/dpp-logo.svg"
                      alt="DPP"
                      className="h-10 p-0"
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                      }}
                    />
                  ),
                },
                {
                  title: (
                    <div
                      className="flex flex-col leading-none"
                      style={{ fontSize: "0.60em" }}
                    >
                      <span style={{ color: "#3CB1C8" }}>QR</span>
                      <span style={{ color: "white" }}>Code</span>
                      <span style={{ color: "white" }}>Manager</span>
                    </div>
                  ),
                },
              ]}
            />
          </div>
          <div className="flex items-center space-x-2">
            <AuthenticatedTemplate>
              <TenantSelector
              tenants={tenants}
              selectedTenant={selectedTenant}
              onTenantSelect={onTenantSelect}
            />
              <span className="text-base">
              {accounts[0]?.name || accounts[0]?.username || "User"}
              </span>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
              <span className="text-base">Please sign in</span>
            </UnauthenticatedTemplate>
            <SignInButton isFromHeader={true} />
          </div>
        </div>
      </header>
    </ConfigProvider>
  );
}

export default React.memo(Header);
